import React, {Component} from "react";
import {request} from "api-client";
import Form from "../Form";
import localization from '../../../config/localization'

export default class extends Component {
  submitRequest = data => {
    const requestData = {
      name: data.name,
      email: data.email,
      description: data.description,
      imageFile: data.image.file,
      roleId: data.roleId,
      language: data.language,
      selectedCreator: data.selectedCreator,
    };

    return request.user.create(requestData);
  };

  render = () => {
    return <Form {...this.props} submitRequest={this.submitRequest} formTitle={localization.get('user.create_user')} type={"create"} />;
  };
}
